export default "__VITE_ASSET__CgSq6FdS__"